import { makeDocumentAPIs } from '../../modules/documentAPIFactory'
import { getOpportunityMSServiceDocumentListData } from './mockData'
import type { IOpportunityMSServiceDocument } from '~/types/document/models'

export const {
  getDocuments: getOpportunityMSServiceDocuments,
  postDocument: postOpportunityMSServiceDocument,
  patchDocument: patchOpportunityMSServiceDocument,
  deleteDocument: deleteOpportunityMSServiceDocument,
  handlers,
} = makeDocumentAPIs<IOpportunityMSServiceDocument>({
  apiPathEntityNamePrefix: 'opportunitymsservice',
  getDocumentListDataFn: getOpportunityMSServiceDocumentListData,
})
